function doResize(node: HTMLElement, offset: number) {
    node.style.height = 'auto';
    node.style.height = node.scrollHeight + offset + 'px';
}

export default function textareaAutoresize() {
    document.querySelectorAll('[data-autoresize]').forEach(function (el) {
        const element = el as HTMLElement;

        element.style.boxSizing = 'border-box';
        const offset = element.offsetHeight - element.clientHeight;
        element.addEventListener('input', function (event) {
            doResize(event.target as HTMLElement, offset);
        });
        doResize(element, offset);
        element.removeAttribute('data-autoresize');
    });
}

export function textareaAutoresizeOne(el: any) {
    const jqel = $(el);

    let offset = jqel.data('autoresize-init');
    if (offset === null || offset === undefined) {
        el.style.boxSizing = 'border-box';
        offset = el.offsetHeight - el.clientHeight;
        jqel.data('autoresize-init', offset);
    }

    doResize(el, offset);
}